import React, { Component } from 'react';
import SearchHeader from "./SearchHeader";
import SearchContent from "./SearchContent";
import axios from "axios/index";

const axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
    }
};

class SearchResults extends Component {





    constructor(props){
        super(props);

        this.state = {
            search: false,
            detail: false,
            data: [],
            images:[],
            listings: [],
        }



        if(this.props.definition == ""){

            axios.get(`https://mportalsystem2.btect.sk/api/listings`)
                .then(res => {
                    const data = res.data[0];

                    this.setState({ listings: data });


                });
        }
        else{

            if(Array.isArray(this.props.definition)) {

                if(this.props.definition.length > 3) {

                    axios.post('https://mportalsystem2.btect.sk/api/filteredlistings', {

                        category: this.props.definition[0],
                        offer: this.props.definition[1],
                        title: this.props.definition[2],
                        tag: this.props.definition[3],
                        country: this.props.definition[4],

                    }, {
                        crossDomain: true
                    })
                        .then(res => {

                            const data = res.data;
                            console.log(data);
                            this.setState({listings: data});
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
                else if(this.props.definition.length==2){

                    axios.post('https://mportalsystem2.btect.sk/api/filteredlistings', {

                        category: this.props.definition[0],

                    }, {
                        crossDomain: true
                    })
                        .then(res => {

                            const data = res.data;
                            console.log(data);
                            this.setState({listings: data});
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
                else if(this.props.definition.length==3){


                    axios.post('https://mportalsystem2.btect.sk/api/filteredlistings', {

                        tag: this.props.definition[0],

                    }, {
                        crossDomain: true
                    })
                        .then(res => {

                            const data = res.data;
                            console.log(data);
                            this.setState({listings: data});
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

            }
            else{


                axios.post('https://mportalsystem2.btect.sk/api/filteredlistings', {


                    country: this.props.definition,

                }, {
                    crossDomain: true
                })
                    .then(res => {

                        const data = res.data;
                        console.log(data);
                        this.setState({listings: data});
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }


        }



        axios.get(`https://mportalsystem2.btect.sk/api/pages/2`)
            .then(res => {
                const data = res.data[0];

                this.setState({ data: data });


            });


        axios.get(`https://mportalsystem2.btect.sk/api/pages/image/2`)
            .then(res => {
                const data = res.data[0];
                this.setState({ images: data });

            })
    }

    findSlug = (slug) => {
        let vysledok = this.state.data;

        this.state.data.map(data => {
                if (data.slug == slug) {
                    vysledok = data.content;
                }
            }
        );
        return vysledok;
    }
    findImageBySlug = (slug) => {
        let vysledok;


        if(this.state.images == ""){
            axios.get(`https://mportalsystem2.btect.sk/api/pages/image/2`)
                .then(res => {
                    const data = res.data[0];
                    this.setState({ images: data });

                })
        }



        this.state.images.map(data => {

                if (data.slug == slug) {



                    vysledok = data.path;
                }
            }
        );

        return vysledok;
    }

    findGroup = (group) => {

        let array = new Array();

        var obje = this.state.data.map(data => {
                if (data.groupa == group) {
                    array.push(data);
                }
            }
        );

        return array;
    }

    componentWillUnmount(){
        this.setState({listing: ""});
    }
    componentDidMount(){

        document.getElementById("root").scrollIntoView();
        if(window.location.pathname != '/') {
            let okres = window.location.pathname.replace('/', '');
            if (!isNaN(okres)) {
               window.location = "/";
            }
        }

    }

    render() {
        return (
            <div className="searchresults">
                <SearchHeader findImageBySlug={this.findImageBySlug} findGroup={this.findGroup} findSlug={this.findSlug}/>

                <SearchContent setSearch={this.props.setSearch} listing={this.state.listings} findImageBySlug={this.findImageBySlug} findGroup={this.findGroup} findSlug={this.findSlug} setDetail = {this.props.setDetail} setSearch = {this.props.setSearch}/>

            </div>
        );
    }
}

export default SearchResults;
